import {connect} from "react-redux"
import {State} from "../../ducks"

export const mapStateToProps = (state: State) => {
    const {
        countrySelector: {selectedLanguage, selectedCountry},
        text: {countryChangeModal},
        request: {siteUrl},
    } = state

    const newSiteUrl = selectedCountry?.Languages?.find(e => e.Name === selectedLanguage)?.TargetUrl
    return {
        selectedCountry,
        selectedLanguage,
        text: countryChangeModal,
        siteUrl,
        newSiteUrl,
    }
}

export default connect(mapStateToProps)
